import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class VisitResult extends BaseEntity{

    visitResultCode : string;
    name : string;
    rank : number;
    revisit : boolean;
    
}
